import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLayerGroup,
  faTags,
  faTag,
  faBookOpen,
  faQuestionCircle,
  faClipboardList,
  faTable,
  faThList,
  faList,
  faFileAlt,
  faCaretSquareDown,
  faUserTag,
  faFileSignature,
  faNoteSticky,
  faEject,
  faClipboardCheck,
  faHourglass,
  faCheck,
  faTimes,
  faSyncAlt,
  faPencil,
  faEdit,
  faAward,
  faFileContract,
  faPlayCircle,
  faExclamationCircle,
  faArchive,
  faSignInAlt,
  faKey,
  faUnlockAlt,
  faUserPlus,
  faUsersCog,
  faIdBadge,
  faShieldAlt,
  faUserTie,
  faWrench,
  faMapMarkerAlt,
  faMapSigns,
  faCity,
  faMobileAlt,
  faEnvelopeOpenText,
  faTachometerAlt,
  faFile,
  faMapMarkedAlt,
  faMapPin,
  faBookmark,
  faCreditCard,
  faFileImage,
  faCircleInfo,
  faFileLines,
  faLink,
  faImage,
  faFileShield,
  faCancel,
  faScaleBalanced,
  faShieldHalved,
  faTriangleExclamation,
  faFileInvoice,
  faUsers,
  faUserGroup,
  faPenToSquare,
  faArrowsRotate,
  faChartSimple,
  faPaperPlane,
  faClock,
  faBan,
  faRotate,
  faArrowRightFromBracket,
  faGlobe,
  faHeading,
  faBars,
  faAlignJustify,
  faListCheck,
  faMoneyCheckAlt,
  faBullseye,
  faUserShield,
  faExclamationTriangle,
  faHistory,
  faFlag,
  faUserClock,
  faBusinessTime,
  faArrowUpRightDots
  
} from "@fortawesome/free-solid-svg-icons";
import {
  checkPermission,
  permissionsConfig,
} from "../AdminPermission/PermissionChecker";

const SideMenu = () => {
  const location = useLocation();
  const pathName = location.pathname;
  const navigate = useNavigate();

  const iconsMap = {
    faChartSimple,
    faLayerGroup,
    faTags,
    faTag,
    faPencil,
    faBookOpen,
    faQuestionCircle,
    faClipboardList,
    faEject,
    faTable,
    faNoteSticky,
    faThList,
    faList,
    faFileAlt,
    faCaretSquareDown,
    faUserTag,
    faFileSignature,
    faClipboardCheck,
    faHourglass,
    faCheck,
    faTimes,
    faSyncAlt,
    faCancel,
    faEdit,
    faAward,
    faFileContract,
    faPlayCircle,
    faExclamationCircle,
    faArchive,
    faSignInAlt,
    faKey,
    faUnlockAlt,
    faUserPlus,
    faUsersCog,
    faIdBadge,
    faShieldAlt,
    faUserTie,
    faWrench,
    faMapMarkerAlt,
    faMapSigns,
    faCity,
    faMobileAlt,
    faEnvelopeOpenText,
    faTachometerAlt,
    faFile,
    faMapMarkedAlt,
    faMapPin,
    faBookmark,
    faCreditCard,
    faFileImage,
    faCircleInfo,
    faFileLines,
    faLink,
    faImage,
    faFileShield,
    faScaleBalanced,
    faShieldHalved,
    faTriangleExclamation,
    faFileInvoice,
    faUsers,
    faUserGroup,
    faPenToSquare,
    faArrowsRotate,
    faPaperPlane,
    faClock,
    faBan,
    faRotate,
    faArrowRightFromBracket,
    faGlobe,
    faHeading,
    faBars,
    faAlignJustify,
    faListCheck,
    faMoneyCheckAlt,
    faBullseye,
    faUserShield,
    faExclamationTriangle,
    faHistory,
    faFlag,
    faBusinessTime,
    faUserClock,
    faArrowUpRightDots
  };

  const superAminPermission = checkPermission("0", "0", "");

  // Simplified permission checks using the permissions config
  const grantPermissionForViewCategories = checkPermission(
    permissionsConfig.viewCategories.role,
    permissionsConfig.viewCategories.action,
    permissionsConfig.viewCategories.type
  );
  const grantPermissionForViewSubCategories = checkPermission(
    permissionsConfig.viewSubCategories.role,
    permissionsConfig.viewSubCategories.action,
    permissionsConfig.viewSubCategories.type
  );
  const grantPermissionForViewGuidelines = checkPermission(
    permissionsConfig.viewGuidelines.role,
    permissionsConfig.viewGuidelines.action,
    permissionsConfig.viewGuidelines.type
  );
  const grantPermissionForViewCategoryFAQList = checkPermission(
    permissionsConfig.viewCategoryFAQList.role,
    permissionsConfig.viewCategoryFAQList.action,
    permissionsConfig.viewCategoryFAQList.type
  );
  const grantPermissionForViewDocumentList = checkPermission(
    permissionsConfig.viewDocumentList.role,
    permissionsConfig.viewDocumentList.action,
    permissionsConfig.viewDocumentList.type
  );

  const grantPermissionForViewCategoryFees = checkPermission(
    permissionsConfig.viewCategoryFees.role,
    permissionsConfig.viewCategoryFees.action,
    permissionsConfig.viewCategoryFees.type
  );

  const grantPermissionForViewFormTabs = checkPermission(
    permissionsConfig.viewFormTabs.role,
    permissionsConfig.viewFormTabs.action,
    permissionsConfig.viewFormTabs.type
  );
  const grantPermissionForViewFormSection = checkPermission(
    permissionsConfig.viewFormSection.role,
    permissionsConfig.viewFormSection.action,
    permissionsConfig.viewFormSection.type
  );
  const grantPermissionForViewFormSubSection = checkPermission(
    permissionsConfig.viewFormSubSection.role,
    permissionsConfig.viewFormSubSection.action,
    permissionsConfig.viewFormSubSection.type
  );
  const grantPermissionForViewFormFields = checkPermission(
    permissionsConfig.viewFormFields.role,
    permissionsConfig.viewFormFields.action,
    permissionsConfig.viewFormFields.type
  );
  const grantPermissionForViewFormDropdowns = checkPermission(
    permissionsConfig.viewFormDropdowns.role,
    permissionsConfig.viewFormDropdowns.action,
    permissionsConfig.viewFormDropdowns.type
  );
  const grantPermissionForViewEmployeeDesignation = checkPermission(
    permissionsConfig.viewEmployeeDesignation.role,
    permissionsConfig.viewEmployeeDesignation.action,
    permissionsConfig.viewEmployeeDesignation.type
  );

  const grantPermissionForViewTotalApplications = checkPermission(
    permissionsConfig.viewTotalApplications.role,
    permissionsConfig.viewTotalApplications.action,
    permissionsConfig.viewTotalApplications.type
  );

  const grantPermissionForViewNewApplications = checkPermission(
    permissionsConfig.viewNewApplications.role,
    permissionsConfig.viewNewApplications.action,
    permissionsConfig.viewNewApplications.type
  );

  const grantPermissionForViewUnderReviewApplications = checkPermission(
    permissionsConfig.viewUnderReviewApplications.role,
    permissionsConfig.viewUnderReviewApplications.action,
    permissionsConfig.viewUnderReviewApplications.type
  );

  const grantPermissionForViewPendingApplications = checkPermission(
    permissionsConfig.viewPendingApplications.role,
    permissionsConfig.viewPendingApplications.action,
    permissionsConfig.viewPendingApplications.type
  );
  const grantPermissionForViewApprovedApplications = checkPermission(
    permissionsConfig.viewApprovedApplications.role,
    permissionsConfig.viewApprovedApplications.action,
    permissionsConfig.viewApprovedApplications.type
  );
  const grantPermissionForViewRejectedApplications = checkPermission(
    permissionsConfig.viewRejectedApplications.role,
    permissionsConfig.viewRejectedApplications.action,
    permissionsConfig.viewRejectedApplications.type
  );

  const grantPermissionForViewRejectedPaymentDocumentApplications = checkPermission(
    permissionsConfig.viewPaymentDocumentRejectedApplications.role,
    permissionsConfig.viewPaymentDocumentRejectedApplications.action,
    permissionsConfig.viewPaymentDocumentRejectedApplications.type
  );

  const grantPermissionForViewExpiredApplications = checkPermission(
    permissionsConfig.viewExpiredApplications.role,
    permissionsConfig.viewExpiredApplications.action,
    permissionsConfig.viewExpiredApplications.type
  );  

  const grantPermissionForViewDisabledApplications = checkPermission(
    permissionsConfig.viewDisabledApplications.role,
    permissionsConfig.viewDisabledApplications.action,
    permissionsConfig.viewDisabledApplications.type
  );

  const grantPermissionForViewDraftApplications = checkPermission(
    permissionsConfig.viewDraftApplications.role,
    permissionsConfig.viewDraftApplications.action,
    permissionsConfig.viewDraftApplications.type
  );

  const grantPermissionForViewWithdrawalApplications = checkPermission(
    permissionsConfig.viewWithdrawalApplications.role,
    permissionsConfig.viewWithdrawalApplications.action,
    permissionsConfig.viewWithdrawalApplications.type
  );

  const grantPermissionForViewTotalRenewApplications = checkPermission(
    permissionsConfig.viewRenewTotalApplications.role,
    permissionsConfig.viewRenewTotalApplications.action,
    permissionsConfig.viewRenewTotalApplications.type
  );

  const grantPermissionForViewNewRenewApplications = checkPermission(
    permissionsConfig.viewRenewNewApplications.role,
    permissionsConfig.viewRenewNewApplications.action,
    permissionsConfig.viewRenewNewApplications.type
  );

  const grantPermissionForViewUnderReviewRenewApplications = checkPermission(
    permissionsConfig.viewRenewUnderReviewApplications.role,
    permissionsConfig.viewRenewUnderReviewApplications.action,
    permissionsConfig.viewRenewUnderReviewApplications.type
  );

  const grantPermissionForViewPendingRenewApplications = checkPermission(
    permissionsConfig.viewRenewPendingApplications.role,
    permissionsConfig.viewRenewPendingApplications.action,
    permissionsConfig.viewRenewPendingApplications.type
  );
  const grantPermissionForViewApprovedRenewApplications = checkPermission(
    permissionsConfig.viewRenewApprovedApplications.role,
    permissionsConfig.viewRenewApprovedApplications.action,
    permissionsConfig.viewRenewApprovedApplications.type
  );
  const grantPermissionForViewRejectedRenewApplications = checkPermission(
    permissionsConfig.viewRenewRejectedApplications.role,
    permissionsConfig.viewRenewRejectedApplications.action,
    permissionsConfig.viewRenewRejectedApplications.type
  );

  const grantPermissionForViewPaymentDocumentRejectedRenewApplications = checkPermission(
    permissionsConfig.viewRenewPaymentDocumentRejectedApplications.role,
    permissionsConfig.viewRenewPaymentDocumentRejectedApplications.action,
    permissionsConfig.viewRenewPaymentDocumentRejectedApplications.type
  );

  const grantPermissionForViewExpiredRenewApplications = checkPermission(
    permissionsConfig.viewRenewExpiredApplications.role,
    permissionsConfig.viewRenewExpiredApplications.action,
    permissionsConfig.viewRenewExpiredApplications.type
  );  

  const grantPermissionForViewDisabledRenewApplications = checkPermission(
    permissionsConfig.viewRenewDisabledApplications.role,
    permissionsConfig.viewRenewDisabledApplications.action,
    permissionsConfig.viewRenewDisabledApplications.type
  );

  const grantPermissionForViewTransactionsList = checkPermission(
    permissionsConfig.viewTransactions.role,
    permissionsConfig.viewTransactions.action,
    permissionsConfig.viewTransactions.type
  );

  const grantPermissionForCertificates = checkPermission(
    permissionsConfig.certificates.role,
    permissionsConfig.certificates.action,
    permissionsConfig.certificates.type
  );
  const grantPermissionForExpired = checkPermission(
    permissionsConfig.expired.role,
    permissionsConfig.expired.action,
    permissionsConfig.expired.type
  );
  const grantPermissionForCertificateCategory = checkPermission(
    permissionsConfig.expired.role,
    permissionsConfig.expired.action,
    permissionsConfig.expired.type
  );

  const grantPermissionForViewLogin = checkPermission(
    permissionsConfig.viewLogin.role,
    permissionsConfig.viewLogin.action,
    permissionsConfig.viewLogin.type
  );
  const grantPermissionForViewResetPassword = checkPermission(
    permissionsConfig.viewResetPassword.role,
    permissionsConfig.viewResetPassword.action,
    permissionsConfig.viewResetPassword.type
  );
  const grantPermissionForViewForgotPassword = checkPermission(
    permissionsConfig.viewForgotPassword.role,
    permissionsConfig.viewForgotPassword.action,
    permissionsConfig.viewForgotPassword.type
  );
  const grantPermissionForViewRegistration = checkPermission(
    permissionsConfig.viewRegistration.role,
    permissionsConfig.viewRegistration.action,
    permissionsConfig.viewRegistration.type
  );

  const grantPermissionForViewHeaderContent = checkPermission(
    permissionsConfig.viewHeaderContent.role,
    permissionsConfig.viewHeaderContent.action,
    permissionsConfig.viewHeaderContent.type
  );

  const grantPermissionForViewContactUs = checkPermission(
    permissionsConfig.viewContactUs.role,
    permissionsConfig.viewContactUs.action,
    permissionsConfig.viewContactUs.type
  );

  const grantPermissionForViewWebsiteLogo = checkPermission(
    permissionsConfig.viewWebsiteLogo.role,
    permissionsConfig.viewWebsiteLogo.action,
    permissionsConfig.viewWebsiteLogo.type
  );

  const grantPermissionForViewHeaderPages = checkPermission(
    permissionsConfig.viewHeaderPages.role,
    permissionsConfig.viewHeaderPages.action,
    permissionsConfig.viewHeaderPages.type
  );

  const grantPermissionForViewBanner = checkPermission(
    permissionsConfig.viewBanner.role,
    permissionsConfig.viewBanner.action,
    permissionsConfig.viewBanner.type
  );

  const grantPermissionForViewBannerLinks = checkPermission(
    permissionsConfig.viewBannerLinks.role,
    permissionsConfig.viewBannerLinks.action,
    permissionsConfig.viewBannerLinks.type
  );

  const grantPermissionForViewRegistrationStep = checkPermission(
    permissionsConfig.viewRegistrationStep.role,
    permissionsConfig.viewRegistrationStep.action,
    permissionsConfig.viewRegistrationStep.type
  );

  const grantPermissionForViewSocialMediaLinks = checkPermission(
    permissionsConfig.viewSocialMediaLinks.role,
    permissionsConfig.viewSocialMediaLinks.action,
    permissionsConfig.viewSocialMediaLinks.type
  );

  const grantPermissionForViewTravelTradeLink = checkPermission(
    permissionsConfig.viewTravelTradeLinks.role,
    permissionsConfig.viewTravelTradeLinks.action,
    permissionsConfig.viewTravelTradeLinks.type
  );

  const grantPermissionForViewTopFooterPages = checkPermission(
    permissionsConfig.viewTopFooterPages.role,
    permissionsConfig.viewTopFooterPages.action,
    permissionsConfig.viewTopFooterPages.type
  );

  const grantPermissionForViewBottomFooterPages = checkPermission(
    permissionsConfig.viewBottomFooterPages.role,
    permissionsConfig.viewBottomFooterPages.action,
    permissionsConfig.viewBottomFooterPages.type
  );

  const grantPermissionForViewPageDocument = checkPermission(
    permissionsConfig.viewPageDocument.role,
    permissionsConfig.viewPageDocument.action,
    permissionsConfig.viewPageDocument.type
  );

  const grantPermissionForViewFooterContent = checkPermission(
    permissionsConfig.viewFooterContent.role,
    permissionsConfig.viewFooterContent.action,
    permissionsConfig.viewFooterContent.type
  );

  const grantPermissionForRolesAndPermissions = checkPermission(
    permissionsConfig.viewRolesAndPermissions.role,
    permissionsConfig.viewRolesAndPermissions.action,
    permissionsConfig.viewRolesAndPermissions.type
  );

  const grantPermissionForViewAdminUser = checkPermission(
    permissionsConfig.viewAdminUser.role,
    permissionsConfig.viewAdminUser.action,
    permissionsConfig.viewAdminUser.type
  );

  const grantPermissionForViewRecoverAdminUser = checkPermission(
    permissionsConfig.viewRecoverAdminUser.role,
    permissionsConfig.viewRecoverAdminUser.action,
    permissionsConfig.viewRecoverAdminUser.type
  );

  const grantPermissionForViewYearlyTarget = checkPermission(
    permissionsConfig.viewYearlyTarget.role,
    permissionsConfig.viewYearlyTarget.action,
    permissionsConfig.viewYearlyTarget.type
  );

  const grantPermissionForViewManageStates = checkPermission(
    permissionsConfig.viewStates.role,
    permissionsConfig.viewStates.action,
    permissionsConfig.viewStates.type
  );
  const grantPermissionForViewManageDistricts = checkPermission(
    permissionsConfig.viewDistricts.role,
    permissionsConfig.viewDistricts.action,
    permissionsConfig.viewDistricts.type
  );
  const grantPermissionForViewManageCities = checkPermission(
    permissionsConfig.viewCities.role,
    permissionsConfig.viewCities.action,
    permissionsConfig.viewCities.type
  );
  const grantPermissionForViewSMSSetting = checkPermission(
    permissionsConfig.viewSMSSetting.role,
    permissionsConfig.viewSMSSetting.action,
    permissionsConfig.viewSMSSetting.type
  );
  const grantPermissionForViewEmailSetting = checkPermission(
    permissionsConfig.viewEmailSetting.role,
    permissionsConfig.viewEmailSetting.action,
    permissionsConfig.viewEmailSetting.type
  );

  const grantPermissionForViewConfiguration = checkPermission(
    permissionsConfig.viewConfiguration.role,
    permissionsConfig.viewConfiguration.action,
    permissionsConfig.viewConfiguration.type
  );

  const grantPermissionForViewPaymentSetting = checkPermission(
    permissionsConfig.viewPaymentSetting.role,
    permissionsConfig.viewPaymentSetting.action,
    permissionsConfig.viewPaymentSetting.type
  );

  const grantPermissionForViewDistrictTotalApplicationsReport = checkPermission(
    permissionsConfig.viewDistrictTotalApplicationsReport.role,
    permissionsConfig.viewDistrictTotalApplicationsReport.action,
    permissionsConfig.viewDistrictTotalApplicationsReport.type
  );

  const grantPermissionForViewDistrictPendingApplicationsReport = checkPermission(
    permissionsConfig.viewDistrictPendingApplicationsReport.role,
    permissionsConfig.viewDistrictPendingApplicationsReport.action,
    permissionsConfig.viewDistrictPendingApplicationsReport.type
  );

  const grantPermissionForViewDistrictDraftApplicationsReport = checkPermission(
    permissionsConfig.viewDistrictDraftApplicationsReport.role,
    permissionsConfig.viewDistrictDraftApplicationsReport.action,
    permissionsConfig.viewDistrictDraftApplicationsReport.type
  );

  const grantPermissionForViewDistrictAcceptedCertificateApplicationsReport = checkPermission(
    permissionsConfig.viewDistrictAcceptedCertificateApplicationsReport.role,
    permissionsConfig.viewDistrictAcceptedCertificateApplicationsReport.action,
    permissionsConfig.viewDistrictAcceptedCertificateApplicationsReport.type
  );

  const grantPermissionForViewDistrictRejectedApplicationsReport = checkPermission(
    permissionsConfig.viewDistrictRejectedApplicationsReport.role,
    permissionsConfig.viewDistrictRejectedApplicationsReport.action,
    permissionsConfig.viewDistrictRejectedApplicationsReport.type
  );

  const grantPermissionForViewDistrictUnderReviewApplicationsReport = checkPermission(
    permissionsConfig.viewDistrictUnderReviewApplicationsReport.role,
    permissionsConfig.viewDistrictUnderReviewApplicationsReport.action,
    permissionsConfig.viewDistrictUnderReviewApplicationsReport.type
  );

  const grantPermissionForViewDistrictYearlyTargetReport = checkPermission(
    permissionsConfig.viewDistrictYearlyTargetReport.role,
    permissionsConfig.viewDistrictYearlyTargetReport.action,
    permissionsConfig.viewDistrictYearlyTargetReport.type
  );

  const grantPermissionForViewOTPLogs = checkPermission(
    permissionsConfig.viewOTPLogs.role,
    permissionsConfig.viewOTPLogs.action,
    permissionsConfig.viewOTPLogs.type
  );

  const grantPermissionForViewAdminLogs = checkPermission(
    permissionsConfig.viewAdminLogs.role,
    permissionsConfig.viewAdminLogs.action,
    permissionsConfig.viewAdminLogs.type
  );

  const grantPermissionForViewUserLogs = checkPermission(
    permissionsConfig.viewUserLogs.role,
    permissionsConfig.viewUserLogs.action,
    permissionsConfig.viewUserLogs.type
  );

  const grantPermissionForViewEmailLogs = checkPermission(
    permissionsConfig.viewEmailLogs.role,
    permissionsConfig.viewEmailLogs.action,
    permissionsConfig.viewEmailLogs.type
  );

  const grantPermissionForViewUserList = checkPermission(
    permissionsConfig.viewUserList.role,
    permissionsConfig.viewUserList.action,
    permissionsConfig.viewUserList.type
  );

  const grantPermissionForViewUpdateDetailsRequest = checkPermission(
    permissionsConfig.viewUpdateDetailsRequest.role,
    permissionsConfig.viewUpdateDetailsRequest.action,
    permissionsConfig.viewUpdateDetailsRequest.type
  );

  const grantPermissionForViewRecoverUser = checkPermission(
    permissionsConfig.viewRecoverUser.role,
    permissionsConfig.viewRecoverUser.action,
    permissionsConfig.viewRecoverUser.type
  );

  const menuPages = {
    menus: [
      // Category Management
      //superAminPermission ? 
      grantPermissionForViewUserList ||
      grantPermissionForViewUpdateDetailsRequest ||
      grantPermissionForViewRecoverUser ? {
            name: "Travel Trade Users",
            icon: "faUsers",
            submenus: [
              grantPermissionForViewUserList
                ? { name: "Users List", path: "/admin/user", icon: "faUserGroup" }
                : undefined,
                grantPermissionForViewUpdateDetailsRequest
                ? {
                    name: "Update Details Requests",
                    path: "/admin/request/mobile-email",
                    icon: "faPenToSquare",
                  }
                : undefined,
                grantPermissionForViewRecoverUser
                ? {
                    name: "Recover Users",
                    path: "/admin/frontend-users",
                    icon: "faArrowsRotate",
                  }
                : undefined,
                {
                  name: "Old Applications",
                  path: "/admin/old-applications",
                  icon: "faHistory",
                },
                {
                  name: "Hotel Visitors Tracking",
                  path: "/admin/visitor-tracking",
                  icon: "faClock",
                }
            ].filter(Boolean), // This will filter out any undefined values
      }
      : null,
      grantPermissionForViewDraftApplications ? {
        name: "Flag Users",
        icon: "faFlag",
        path: "/admin/flag-users",
        submenus: [
        ].filter(Boolean)
      } : null,
      grantPermissionForViewCategories ||
      grantPermissionForViewSubCategories ||
      grantPermissionForViewGuidelines ||
      grantPermissionForViewCategoryFAQList ||
      grantPermissionForViewDocumentList ||
      grantPermissionForViewCategoryFees
        ? {
            name: "Category Management",
            icon: "faLayerGroup",
            submenus: [
              grantPermissionForViewCategories
                ? {
                    name: "Categories",
                    path: "/admin/categories",
                    icon: "faList",
                  }
                : undefined,
              grantPermissionForViewSubCategories
                ? {
                    name: "Sub Categories",
                    path: "/admin/sub-categories",
                    icon: "faTag",
                  }
                : undefined,
              grantPermissionForViewGuidelines
                ? {
                    name: "Guidelines",
                    path: "/admin/guidelines",
                    icon: "faBookOpen",
                  }
                : undefined,
              // grantPermissionForViewCategoryFAQList
              //   ? {
              //       name: "FAQs",
              //       path: "/admin/faqs",
              //       icon: "faQuestionCircle",
              //     }
              //   : undefined,
              grantPermissionForViewDocumentList
                ? {
                    name: "Documents",
                    path: "/admin/category/documents",
                    icon: "faBookmark",
                  }
                : undefined,
              grantPermissionForViewCategoryFees
                ? {
                    name: "Fees",
                    path: "/admin/category/fees",
                    icon: "faCreditCard",
                  }
                : undefined,
            ].filter(Boolean), // This will filter out any undefined values
          }
        : null,

      // Form Management
      grantPermissionForViewFormTabs ||
      grantPermissionForViewFormSection ||
      grantPermissionForViewFormSubSection ||
      grantPermissionForViewFormFields ||
      grantPermissionForViewFormDropdowns ||
      grantPermissionForViewEmployeeDesignation
        ? {
            name: "Form Management",
            icon: "faClipboardList",
            submenus: [
              grantPermissionForViewFormTabs
                ? {
                    name: "Form Tabs",
                    path: "/admin/form/tabs",
                    icon: "faTable",
                  }
                : undefined,
              grantPermissionForViewFormSection
                ? {
                    name: "Form Sections",
                    path: "/admin/form/sections",
                    icon: "faThList",
                  }
                : undefined,
              grantPermissionForViewFormSubSection
                ? {
                    name: "Form Sub Sections",
                    path: "/admin/form/sub-sections",
                    icon: "faList",
                  }
                : undefined,
              grantPermissionForViewFormFields
                ? {
                    name: "Form Fields",
                    path: "/admin/form/fields",
                    icon: "faFileAlt",
                  }
                : undefined,
              grantPermissionForViewFormDropdowns
                ? {
                    name: "Form Dropdowns",
                    path: "/admin/form/dropdowns",
                    icon: "faCaretSquareDown",
                  }
                : undefined,
              grantPermissionForViewEmployeeDesignation
                ? {
                    name: "Employee Designations",
                    path: "/admin/employee-designations",
                    icon: "faUserTag",
                  }
                : undefined,
            ].filter(Boolean), // This will filter out any undefined values
          }
        : null,

      // Application Management
      grantPermissionForViewTotalApplications ||
      grantPermissionForViewNewApplications ||
      grantPermissionForViewUnderReviewApplications ||
      grantPermissionForViewPendingApplications ||
      grantPermissionForViewApprovedApplications ||
      grantPermissionForViewRejectedApplications ||
      grantPermissionForViewRejectedPaymentDocumentApplications ||
      grantPermissionForViewExpiredApplications ||
      grantPermissionForViewDisabledApplications
        ? {
        name: "Application Management",
        icon: "faFileSignature",
        submenus: [
          grantPermissionForViewTotalApplications
            ? {
                name: "All",
                path: "/admin/total-applications",
                icon: "faList",
              }
            : undefined,
          grantPermissionForViewNewApplications
            ? {
              name: "New",
                path: "/admin/new-applications",
                icon: "faPaperPlane",
              }
            : undefined,
          grantPermissionForViewNewApplications
            ? {
              name: "Revised Policy Payment Due",
                path: "/admin/revised-policy-payment-due-applications",
                icon: "faArrowUpRightDots",
              }
            : undefined,
          grantPermissionForViewUnderReviewApplications
            ? {
            name: "Under Review",
            path: "/admin/under-review-applications",
            icon: "faEdit",
          } : undefined,
          grantPermissionForViewPendingApplications
            ? {
              name: "Document Pending",
                path: "/admin/pending-applications",
                icon: "faHourglass",
              }
            : undefined,
          grantPermissionForViewApprovedApplications
            ? {
                name: "Approved/Certificate",
                path: "/admin/approved-applications",
                icon: "faCheck",
              }
            : undefined,
          grantPermissionForViewRejectedApplications
            ? {
                name: "Rejected",
                path: "/admin/rejected-applications",
                icon: "faTimes",
              }
            : undefined,
          grantPermissionForViewRejectedPaymentDocumentApplications
            ? {
                name: "Payment Document Rejected",
                path: "/admin/payment-document-rejected-applications",
                icon: "faExclamationTriangle",
              }
            : undefined,
          // grantPermissionForViewExpiredApplications
          //   ? {
          //       name: "Expired",
          //       path: "/admin/expired-applications",
          //       icon: "faClock",
          //     }
          //   : undefined,
          grantPermissionForViewDisabledApplications
            ? {
                name: "Disable Applications",
                path: "/admin/disable-applications",
                icon: "faBan",
              }
            : undefined,
        ].filter(Boolean), // This will filter out any undefined values
      } : null,
      grantPermissionForViewDraftApplications ? {
        name: "Draft/Payment Due Application",
        icon: "faNoteSticky",
        path: "/admin/draft-applications",
        submenus: [
        ].filter(Boolean)
      } : null,
      grantPermissionForViewWithdrawalApplications ? {
        name: "Withdrawal Application",
        icon: "faArrowRightFromBracket",
        path: "/admin/withdrawal-applications",
        submenus: [
        ].filter(Boolean)
      } : null,
      grantPermissionForViewTotalApplications
        ? {
        name: "Pending Reports",
        icon: "faClock",
        submenus: [
          grantPermissionForViewTotalApplications
            ? {
                name: "User Side Pending Applications",
                path: "/admin/user-pending-applications",
                icon: "faUserClock",
              }
            : undefined,
          grantPermissionForViewTotalApplications
            ? {
              name: "DTDO Side Pending Applications",
                path: "/admin/dtdo-pending-applications",
                icon: "faBusinessTime",
              }
            : undefined,
        ].filter(Boolean), // This will filter out any undefined values
      } : null,
      // grantPermissionForViewTotalRenewApplications ||
      // grantPermissionForViewNewRenewApplications ||
      // grantPermissionForViewUnderReviewRenewApplications ||
      // grantPermissionForViewPendingRenewApplications ||
      // grantPermissionForViewApprovedRenewApplications ||
      // grantPermissionForViewRejectedRenewApplications ||
      // grantPermissionForViewPaymentDocumentRejectedRenewApplications ||
      // grantPermissionForViewExpiredRenewApplications ||
      // grantPermissionForViewDisabledRenewApplications
      //   ? {
      //   name: "Renew Application",
      //   icon: "faRotate",
      //   // path: "/admin/withdrawal-applications"
      //   submenus: [
      //     grantPermissionForViewTotalApplications
      //       ? {
      //       name: "All",
      //       path: "/admin/renew/all",
      //       icon: "faList",
      //     }: undefined,
      //     grantPermissionForViewNewRenewApplications
      //       ? {
      //       name: "New",
      //       path: "/admin/renew/new",
      //       icon: "faPaperPlane",
      //     }: undefined,
      //     grantPermissionForViewUnderReviewRenewApplications
      //       ? {
      //       name: "Under Review",
      //       path: "/admin/renew/under-review",
      //       icon: "faEdit",
      //     }: undefined,
      //     grantPermissionForViewPendingRenewApplications
      //       ? {
      //       name: "Document Pending",
      //       path: "/admin/renew/document-pending",
      //       icon: "faHourglass",
      //     }: undefined,
      //     grantPermissionForViewApprovedRenewApplications
      //       ? {
      //       name: "Accepted/Cerificate",
      //       path: "/admin/renew/accepted",
      //       icon: "faCheck",
      //     }: undefined,
      //     grantPermissionForViewRejectedRenewApplications
      //       ? {
      //       name: "Rejected",
      //       path: "/admin/renew/rejected",
      //       icon: "faTimes",
      //     }: undefined,
      //     grantPermissionForViewPaymentDocumentRejectedRenewApplications
      //       ? {
      //       name: "Payment Document Rejected",
      //       path: "/admin/renew/payment-document-rejected",
      //       icon: "faExclamationTriangle",
      //     }: undefined,
      //     grantPermissionForViewExpiredRenewApplications
      //       ? {
      //       name: "Expired",
      //       path: "/admin/renew/expired",
      //       icon: "faClock",
      //     }: undefined,
      //     grantPermissionForViewDisabledRenewApplications
      //       ? {
      //       name: "Disable Application",
      //       path: "/admin/renew/disable",
      //       icon: "faBan",
      //     }: undefined
      //   ].filter(Boolean)
      // } : null,
      grantPermissionForViewTransactionsList ? {
        name: "Transaction List",
        icon: "faMoneyCheckAlt",
        path: "/admin/transaction-list",
        submenus: [
        ].filter(Boolean)
      } : null,
      // Certificate Management
      superAminPermission
        ? {
            name: "Certificate Type",
            icon: "faAward",
          submenus: [
            // grantPermissionForCertificates
            //   ? {
            //     name: "Certificates",
            //     path: "/admin/certificates",
            //     icon: "faFileContract",
            //   }
            //   : undefined,
            // {
            //   name: "Active",
            //   path: "/admin/active-certificates",
            //   icon: "faPlayCircle",
            // },
            // grantPermissionForExpired
            //   ? {
            //     name: "Expired",
            //     path: "/admin/expired-certificates",
            //     icon: "faExclamationCircle",
            //   }
            //   : undefined,
            grantPermissionForExpired
              ? {
                name: "List",
                path: "/admin/certificate-type",
                icon: "faExclamationCircle",
              }
              : undefined,
            //{ name: "Logs", path: "", icon: "faArchive" },
            ].filter(Boolean), // This will filter out any undefined values
          }
        : null,
      // Pages
      grantPermissionForViewLogin ||
      grantPermissionForViewResetPassword ||
      grantPermissionForViewForgotPassword ||
      grantPermissionForViewRegistration ||
      grantPermissionForViewHeaderContent ||
      grantPermissionForViewContactUs ||
      grantPermissionForViewWebsiteLogo ||
      grantPermissionForViewHeaderPages ||
      grantPermissionForViewBanner ||
      grantPermissionForViewBannerLinks ||
      grantPermissionForViewRegistrationStep ||
      grantPermissionForViewSocialMediaLinks ||
      grantPermissionForViewTravelTradeLink ||
      grantPermissionForViewTopFooterPages ||
      grantPermissionForViewBottomFooterPages ||
      grantPermissionForViewPageDocument ||
      grantPermissionForViewFooterContent
        ? {
            name: "Home Page Management",
            icon: "faFile",
            submenus: [
              grantPermissionForViewLogin
                ? { name: "Login", path: "/admin/login", icon: "faSignInAlt" }
                : undefined,
              grantPermissionForViewResetPassword
                ? {
                    name: "Reset Password",
                    path: "/admin/reset-password",
                    icon: "faKey",
                  }
                : undefined,
              grantPermissionForViewForgotPassword
                ? {
                    name: "Forgot Password",
                    path: "/admin/forgot-password",
                    icon: "faUnlockAlt",
                  }
                : undefined,
              grantPermissionForViewRegistration
                ? {
                    name: "Registration",
                    path: "/admin/registration",
                    icon: "faUserPlus",
                  }
                : undefined,
              grantPermissionForViewHeaderContent
                ? {
                    name: "Header Content",
                    path: "/admin/header-content",
                    icon: "faFileAlt",
                  }
                : undefined,
              grantPermissionForViewContactUs
                ? {
                    name: "Contact Us",
                    path: "/admin/contactus",
                    icon: "faFileAlt",
                  }
                : undefined,
              grantPermissionForViewWebsiteLogo
                ? {
                name: "Website Logo",
                path: "/admin/homepage-logo",
                icon: "faImage",
              } : undefined,
              grantPermissionForViewHeaderPages
                ? {
                "name": "Header Pages",
                "path": "/admin/header-pages",
                "icon": "faHeading"
              } : undefined,
              grantPermissionForViewBanner
                ? {
                name: "Banner",
                path: "/admin/banner-page",
                icon: "faFileImage",
              } : undefined,
              grantPermissionForViewBannerLinks 
              ? {
                name: "Banner Links",
                path: "/admin/banner-link",
                icon: "faTags",
              } : undefined,
              grantPermissionForViewRegistrationStep
                ? {
                name: "Registration Steps",
                path: "/admin/registration-steps",
                icon: "faListCheck",
              } : undefined,
              grantPermissionForViewSocialMediaLinks
              ? {
                name: "Social Media Links",
                path: "/admin/social-media-links",
                icon: "faLink",
              } : undefined,
              grantPermissionForViewTravelTradeLink
                ? {
                "name": "Travel Trade Links",
                "path": "/admin/travel-trade-links",
                "icon": "faGlobe"
              } : undefined,
              grantPermissionForViewTopFooterPages
                ? {
                "name": "Top Footer Pages",
                "path": "/admin/top-footer-pages",
                "icon": "faBars"
              } : undefined,
              grantPermissionForViewBottomFooterPages
                ? {
                "name": "Bottom Footer Pages",
                "path": "/admin/bottom-footer-pages",
                "icon": "faAlignJustify"
              } : undefined,
              grantPermissionForViewPageDocument
                ? {
                name: "Page Document",
                path: "/admin/page-document",
                icon: "faFileLines",
              } : undefined,
              grantPermissionForViewFooterContent
                ? {
                "name": "Footer Content",
                "path": "/admin/footer-content",
                "icon": "faEdit"
              } : undefined,
            ].filter(Boolean), // This will filter out any undefined values
          }
        : null,

      // Admin Management
      grantPermissionForRolesAndPermissions||
      grantPermissionForViewAdminUser||
      grantPermissionForViewRecoverAdminUser ||
      grantPermissionForViewYearlyTarget
        ? {
            name: "Admin Management",
            icon: "faUsersCog",
            submenus: [
              grantPermissionForRolesAndPermissions
                ? {
                    name: "Roles and Permissions",
                    path: "/admin/roles",
                    icon: "faIdBadge",
                  }
                : undefined,
              grantPermissionForViewAdminUser
                ? {
                    name: "Admin User",
                    path: "/admin/admin-users",
                    icon: "faUserTie",
                  }
                : undefined,
              grantPermissionForViewRecoverAdminUser
              ? {
                  name: "Recover Admin User",
                  path: "/admin/recover-users",
                  icon: "faArrowsRotate",
                }
              : undefined,  
              grantPermissionForViewYearlyTarget ? {
                name: "Yearly Target",
                path: "/admin/yearly-targets",
                icon: "faChartSimple",
              } : undefined, 
            ].filter(Boolean), // This will filter out any undefined values
          }
        : null,

      // Settings Module
      grantPermissionForViewManageStates ||
      grantPermissionForViewManageDistricts ||
      grantPermissionForViewManageCities ||
      grantPermissionForViewSMSSetting ||
      grantPermissionForViewEmailSetting ||
      grantPermissionForViewPaymentSetting ||
      grantPermissionForViewConfiguration
        ? {
            name: "Settings Module",
            icon: "faWrench",
            submenus: [
              grantPermissionForViewManageStates
                ? {
                    name: "Manage States",
                    path: "/admin/states",
                    icon: "faMapMarkedAlt",
                  }
                : undefined,
              grantPermissionForViewManageDistricts
                ? {
                    name: "Manage Districts",
                    path: "/admin/districts",
                    icon: "faMapPin",
                  }
                : undefined,
              grantPermissionForViewManageCities
                ? {
                    name: "Manage Cities",
                    path: "/admin/cities",
                    icon: "faCity",
                  }
                : undefined,
              grantPermissionForViewSMSSetting
                ? {
                    name: "SMS - Settings",
                    path: "/admin/sms-setting",
                    icon: "faMobileAlt",
                  }
                : undefined,
                
              grantPermissionForViewEmailSetting
                ? {
                    name: "Email - Settings",
                    path: "/admin/email-setting",
                    icon: "faEnvelopeOpenText",
                  }
                : undefined,
              grantPermissionForViewPaymentSetting
                ? {
                    name: "Payment - Settings",
                    path: "/admin/payment/tab",
                    icon: "faFileInvoice",
                  }
                : undefined,
              grantPermissionForViewConfiguration ? {
                name: "Configurations",
                path: "/admin/configurations",
                icon: "faMobileAlt",
              } : undefined
            ].filter(Boolean), // This will filter out any undefined values
          }
        : null,
      grantPermissionForViewDistrictTotalApplicationsReport ||
      grantPermissionForViewDistrictPendingApplicationsReport ||
      grantPermissionForViewDistrictDraftApplicationsReport ||
      grantPermissionForViewDistrictAcceptedCertificateApplicationsReport ||
      grantPermissionForViewDistrictRejectedApplicationsReport ||
      grantPermissionForViewDistrictUnderReviewApplicationsReport ||
      grantPermissionForViewDistrictYearlyTargetReport
        ? {
          name: "Reports",
          icon: "faAward",
          submenus: [
            grantPermissionForViewDistrictTotalApplicationsReport ? {
              name: "District Total Applications",
              path: "/admin/all-applications-report",
              icon: "faFileContract",
            } : undefined,
            grantPermissionForViewDistrictTotalApplicationsReport ? {
              name: "Categories Applications",
              path: "/admin/categories-applications-report",
              icon: "faFileContract",
            } : undefined,
            grantPermissionForViewDistrictPendingApplicationsReport ? {
              name: "District Document Pending Applications",
              path: "/admin/all-pending-report",
              icon: "faFileContract",
            } : undefined,
            grantPermissionForViewDistrictDraftApplicationsReport ? {
              name: "District Draft Applications",
              path: "/admin/all-draft-report",
              icon: "faPlayCircle",
            } : undefined,
            grantPermissionForViewDistrictAcceptedCertificateApplicationsReport ? {
              name: "District Accepted/Certificate Applications",
              path: "/admin/all-approved-report",
              icon: "faExclamationCircle",
            } : undefined,
            grantPermissionForViewDistrictRejectedApplicationsReport ? {
              name: "District Rejected Applications",
              path: "/admin/all-rejected-report",
              icon: "faFileContract",
            } : undefined,
            grantPermissionForViewDistrictUnderReviewApplicationsReport ? {
              name: "District Under Review Applications",
              path: "/admin/all-under-review-report",
              icon: "faPlayCircle",
            } : undefined,
            grantPermissionForViewDistrictYearlyTargetReport ? {
              name: "District Yearly Target",
              path: "/admin/yearly-target-report",
              icon: "faBullseye",
            } : undefined,
          ].filter(Boolean), // This will filter out any undefined values
        }
        : null,
      grantPermissionForViewOTPLogs ||
      grantPermissionForViewAdminLogs || 
      grantPermissionForViewUserLogs || 
      grantPermissionForViewEmailLogs ? {
        name: "Logs",
        icon: "faTable",
        submenus: [
          grantPermissionForViewOTPLogs ? { name: "OTP Logs", path: "/admin/otp-logs", icon: "faMapMarkedAlt" } : undefined,
          superAminPermission ? { name: "Super Admin Logs", path: "/admin/superadmin-logs-list", icon: "faUserShield" } : undefined,
          grantPermissionForViewAdminLogs ? { name: "Admin Logs", path: "/admin/admin-logs-list", icon: "faUserTie" } : undefined,
          grantPermissionForViewUserLogs ? { name: "User Logs", path: "/admin/user-logs-list", icon: "faUsers" } : undefined,
          grantPermissionForViewEmailLogs ? { name: "Email Logs", path: "/admin/email-log", icon: "faMapMarkedAlt" } : undefined,
        ].filter(Boolean), // This will filter out any undefined values
      } : null,
    ].filter(Boolean), // Filter out any null sections
  };

  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  useEffect(() => {
    const activeMenuIndex = menuPages.menus.findIndex((menu) =>
      menu.submenus.some(
        (submenu) => pathName.endsWith(submenu.path) && submenu.path.length > 0
      )
    );
    setOpenMenuIndex(activeMenuIndex !== -1 ? activeMenuIndex : null);
  }, [pathName]);

  useEffect(() => {
    const activeElement = document.querySelector(`.sub-menu-item[data-path="${location.pathname}"]`);
    if (activeElement) {
      activeElement.scrollIntoView({
        block: "center",
      });
    }
  }, [openMenuIndex]);

  const toggleMenu = (index) => {
    setOpenMenuIndex((prevState) => (prevState === index ? null : index));
  };

  return (
    <div className="side-menu adm-side-menu" id="LeftMenu">
      <ul className="ds-ul">
        <li
          onClick={() => navigate("/admin")}
          style={
            pathName.endsWith("/admin")
              ? { backgroundColor: "rgb(0 174 239)" }
              : { backgroundColor: "none" }
          }
        >
          <button
            className={
              pathName.endsWith("/admin")
                ? "bg_image_green"
                : "bg_image_white first-li"
            }
          >
            {" "}
            <FontAwesomeIcon icon={faTachometerAlt} /> <span>Dashboard</span>
          </button>
        </li>
        {menuPages.menus.map((menu, index) => (
          <li
              key={index}
              style={
                ((openMenuIndex === index &&
                  menu.submenus.some(
                  (submenu) =>
                    pathName.endsWith(submenu.path) && submenu.path.length > 0
                  )) || 
                  (menu?.path && pathName?.endsWith(menu?.path) &&
                      menu?.path.length > 0))
                  ? { backgroundColor: "rgb(0 174 239)" }
                  : { backgroundColor: "none" }
              }
              onClick={(e) => {
                e.stopPropagation();
                if(menu?.path && menu?.path?.length > 0){
                  navigate(menu?.path);
                }
              }}
            >
            <button
              className={
                menu?.path && pathName?.endsWith(menu?.path) &&
                menu?.path.length > 0
                  ? "bg_image_green"
                  : "bg_image_white"
              }
              onClick={() => toggleMenu(index)}
            >
              <span className="icon-text">
                <FontAwesomeIcon
                  icon={iconsMap[menu.icon] || iconsMap.default}
                />
                <span style={{ width: "auto" }}>{menu.name}</span>
              </span>
              {menu.submenus && menu.submenus.length > 0 ? (
                openMenuIndex === index ? (
                  <FaChevronDown
                    style={{ marginLeft: "7px", marginTop: "2px" }}
                  />
                ) : (
                  <FaChevronRight
                    style={{ marginLeft: "7px", marginTop: "2px" }}
                  />
                ) // Chevron for collapse
              ) : null}
            </button>

            {menu.submenus && menu.submenus.length > 0 && openMenuIndex === index && (
              <ul className="nested-ul">
                {menu.submenus.map((submenu, index) => (
                  <li
                    key={index}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(submenu.path);
                    }}
                    className={`sub-menu-item ${pathName?.endsWith(submenu.path) ? "active" : ""}`}
                    data-path={submenu.path}
                  >
                    <button
                      className={
                        pathName?.endsWith(submenu.path) &&
                        submenu.path.length > 0
                          ? "bg_image_green"
                          : "bg_image_white"
                      }
                    >
                      <FontAwesomeIcon
                        icon={iconsMap[submenu.icon] || iconsMap.default}
                      />
                      <span>{submenu.name}</span>
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SideMenu;
